'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarouselBrowserify = require('slick-carousel-browserify');

var _slickCarouselBrowserify2 = _interopRequireDefault(_slickCarouselBrowserify);

var _teamMember = require('../molecules/team-member.vue');

var _teamMember2 = _interopRequireDefault(_teamMember);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'team-member': _teamMember2.default
    },
    props: ['teamMembers'],
    ready: function ready() {
        (0, _jquery2.default)('.team-members').slick({
            dots: true,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 3,
            variableHeight: true,
            responsive: [{
                breakpoint: 900,
                settings: {
                    arrows: true,
                    slidesToShow: 3,
                    slidesToScroll: 2
                }
            }, {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 550,
                settings: {
                    arrows: true,
                    centerMode: false,
                    centerPadding: '0',
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 375,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '30px',
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<ul class=\"team-members\">\n    <li v-for=\"teamMember of teamMembers\" class=\"team-members__item\">\n        <team-member :member=\"teamMember\"></team-member>\n    </li>\n</ul>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-371f1cd8", module.exports)
  } else {
    hotAPI.update("_v-371f1cd8", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}